// GOOGLE MAPS

var advmap;
var boundsadvmap;
var markersadvmap = [];
var lastOpenedInfoWindow;
var lastOpenedMarker;

// var markers2;
var iconmarkers = {};

var markerNicolaus = new google.maps.Marker({
    url: window.appUrl + "/images/marker-nc.svg",
    scaledSize: new google.maps.Size(50, 50)
});
var markerGeneral = new google.maps.Marker({
    url: window.appUrl + "/images/marker-gen.svg",
    scaledSize: new google.maps.Size(30, 40)
});

// var markerTurchese = new google.maps.Marker({
//     url: window.appUrl + "/images/marker-t.svg",
//     scaledSize: new google.maps.Size(100, 100)
// });

const styles = require("./mapstyle.json");


if ($("#map")[0]) {
    initDefaultMap(markers);
}

if ($("#destination-map")[0]) {
    initMap('destination-map', markers);
}

if ($("#offer-structure-map")[0]) {
    initMap('offer-structure-map', markers);
}

if ($("#brand-structure-map")[0]) {
    initMap('brand-structure-map', markers);
}

if ($("#structure-map")[0]) {
    initMap('structure-map', markers);
}



var codeh = {drop: '', pill: ''}
// FILTER HOME MAP
$('.dmshomefilter').on('click', function() {
    var textDefault = 'Filtra'
    var markerFiltered = []
    var count = 0

    if (!$(this).hasClass('actived')) {
        
        if($(this).hasClass('dropdown-item')) {
            $('.dropdown-item.dmshomefilter').removeClass('actived')
            codeh.drop = $(this).data("code")
            $("#chooseHomeMarkers").text('Filtra per: ' + $(this).text())
        } else {
            $('.filter-icon').removeClass('actived')
            codeh.pill = $(this).data("code")
        }
        
        $(this).addClass('actived')
                    
        if(codeh.drop != '' && codeh.pill != '') {
            $.each(markers, function(m, mark) {
                if (mark.type.indexOf(codeh.drop) > -1 && mark.collections.indexOf(codeh.pill) > -1) {
                    count++
                    markerFiltered.push(mark)
                }
            })
        } else if (codeh.drop == '') {
            $.each(markers, function(m, mark) {
                if (mark.collections.indexOf(codeh.pill) > -1) {
                    count++
                    markerFiltered.push(mark)
                }
            })
        } else if (codeh.pill == '') {
            $.each(markers, function(m, mark) {
                if (mark.type.indexOf(codeh.drop) > -1) {
                    count++
                    markerFiltered.push(mark)
                }
            })
        }

        initDefaultMap(markerFiltered)
        $('#numesighome').text(count)

    } else {
        $(this).removeClass('actived')
        if($(this).hasClass('dropdown-item')) {
            $('#chooseHomeMarkers').text(textDefault)
            codeh.drop = ''
        } else {
            codeh.pill = ''
        }

        if(codeh.drop == '' && codeh.pill == '') {
            $('#numesighome').text(markers.length)
            initDefaultMap(markers)
        } else if (codeh.drop != '') {
            $.each(markers, function(m, mark) {
                if (mark.type.indexOf(codeh.drop) > -1) {
                    count++
                    markerFiltered.push(mark)
                }
            })
            initDefaultMap(markerFiltered)
            $('#numesighome').text(count)

        } else if (codeh.pill != '') {
            $.each(markers, function(m, mark) {
                if (mark.collections.indexOf(codeh.pill) > -1) {
                    count++
                    markerFiltered.push(mark)
                }
            })
            initDefaultMap(markerFiltered)
            $('#numesighome').text(count)
        }
    }
})
// END FILTER HOME MAP



// DROPDOWN BRAND STRUCTURE
$(".section-brand-structure .dropdown-item.dest").on("click", function() {
    var locality = "";
    if ($(this).is(".default")) {
        $(".section-brand-structure .dropdown-toggle-name")
            .text("destinazione")
            .removeClass("dropdown-toggle-name-style");

        $(".brand-structure")
            .parent()
            .removeClass("d-none");
    } else {
        var locality = $(this).text();
        $(".section-brand-structure .dropdown-toggle-name")
            .text(locality)
            .addClass("dropdown-toggle-name-style");
        if (locality) {
            $(".brand-structure").each(function(i, obj) {
                $(obj)
                    .parent()
                    .removeClass("d-none");
                if ($(".location div", obj).text() != locality) {
                    $(obj)
                        .parent()
                        .addClass("d-none");
                }
            });
        }
    }

    var coll = $(".filterbrandstr.active").data("collection");
    if (coll) filterByEsig(coll);

    if (markers) {
        var markerFiltered = [];
        $.each(markers, function(m, mark) {
            if (
                (!coll || (coll && mark.collections.indexOf(coll) > -1)) &&
                (!locality || (locality && mark.region == locality))
            ) {
                markerFiltered.push(mark);
            }
        });
        initMap('brand-structure-map', markerFiltered);
    }
});
// END DROPDOWN BRAND STRUCTURE

function filterByEsig(coll) {
    $(".brand-structure").each(function(i, obj) {
        if (
            !$(obj)
                .parent()
                .hasClass("d-none") &&
            $(obj)
                .data("collection")
                .indexOf(coll) < 0
        )
            $(obj)
                .parent()
                .addClass("d-none");
    });
}

$(".filterbrandstr").on("dblclick", function() {
    $(this).removeClass("active");
    $(".brand-structure")
        .parent()
        .removeClass("d-none");
    if (markers) {
        initMap('brand-structure-map', markers);
    }
});

$(".filterbrandstr").on("click", function() {
    var locality = ""
    $(".brand-structure").parent().removeClass("d-none")
    var coll = $(this).data("collection")
    if (coll) filterByEsig(coll)
    if ($(".section-brand-structure .dropdown-toggle-name").hasClass("dropdown-toggle-name-style")) {
        locality = $(".section-brand-structure .dropdown-toggle-name").text()
        $(".brand-structure").each(function(i, obj) {
            if ($(".location div", obj).text() != locality) {
                $(obj).parent().addClass("d-none")
            }
        })
    }
    if (markers) {
        var markerFiltered = []
        $.each(markers, function(m, mark) {
            if (mark.collections.indexOf(coll) > -1 && (!locality || (locality && mark.region == locality))) {
                markerFiltered.push(mark)
            }
        })
        initMap('brand-structure-map', markerFiltered)
    } else {
        initMap('brand-structure-map', markers)
    }
});






// FILTER DESTINATION
$(".dmsfilter").on("click", function() {
    if(!$(this).hasClass('dropdown-item') && $(this).hasClass('active')) {
        $(this).removeClass("active");
        $(".destination-structure-card").show();
        initMap('destination-map', markers);
        $("#dmsnumf").text($(".destination-structure-card").length);
    } else if (!$(this).hasClass('dropdown-item') || !$(this).hasClass('active')) {
        $(".dmsfilter").removeClass("active");
        $(this).addClass("active");
        var code = $(this).data("code");
        var count = 0;
        var markerFiltered = [];
        $(".destination-structure-card").show();
        $.each($(".destination-structure-card"), function(m, el) {
            if ($(el).data("catcode") == code) {
                count++;
                $(el).show()
            } else {
                $(el).hide()
            } 
        });

        $.each(markers, function(m, mark) {
            if (mark.type.indexOf(code) > -1) {
                markerFiltered.push(mark);
            }
        });
        initMap('destination-map', markerFiltered);

        $("#dmsnumf").text(count);
    } else {
        var textDefault = "Filtra";
        $(".destination-structure-card").show();
        $(this).removeClass("active");
        initMap('destination-map', markers);
        $("#chooseDestination").text(textDefault);
    }
});

// $(".dmsfilter").on("dblclick", function() {
//     if ($(this).hasClass('active')) {
//     }
// });
// END FILTER DESTINATION



function initDefaultMap(markers) {
    const myLatLng = new google.maps.LatLng(42.188294, 12.677061);

    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 6,
        center: myLatLng,
        mapTypeControl: false,
        scrollwheel: false,
        panControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        rotateControl: false,
        zoomControl: true
    });

    map.setOptions({ styles: styles });

    printMarkers(map, markers);
}

function initMap(id, markers) {
    var bounds = new google.maps.LatLngBounds();
    //const myLatLng = new google.maps.LatLng(40.3770824, 17.4392631);

    const map = new google.maps.Map(document.getElementById(id), {
        // maxZoom: 12,
        //center: myLatLng,
        mapTypeControl: false,
        scrollwheel: false,
        panControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        rotateControl: false,
        zoomControl: true,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL,
            position: google.maps.ControlPosition.TOP_RIGHT
        }
    });

    map.setOptions({ styles: styles });

    printMarkers(map, markers, bounds);
}



function printMarkers(map, markers, bounds) {
    var markclust = [];
    if (typeof markers !== "undefined" && markers.length >= 1) {
        $.each(markers, function(m, mark) {
            var coords = mark["coords"];
            var type = mark["type"];
            var prime = mark["prime"];

            if (coords && typeof coords === "string") {
                var Lat = parseFloat(coords.split(",")[0]);
                var Lng = parseFloat(coords.split(",")[1]);

                if (!Lat || !Lng) {
                    var Lat = parseFloat(coords.split(";")[0]);
                    var Lng = parseFloat(coords.split(";")[1]);
                }
                if (Lat && Lng) {
                    var position = new google.maps.LatLng(Lat, Lng);

                    if (type == "PROD_NC" && !prime) {
                        iconmarkers["marker_" + mark.index] = "PROD_NC";
                        window["marker_" + mark.index] = new google.maps.Marker(
                            {
                                position: position,
                                map: map,
                                icon: markerNicolaus,
                                title: mark["title"]
                            }
                        );
                    } else if (prime) {
                        iconmarkers["marker_" + mark.index] = "PROD_NCP";
                        window["marker_" + mark.index] = new google.maps.Marker(
                            {
                                position: position,
                                map: map,
                                icon: markerNicolaus,
                                title: mark["title"]
                            }
                        );
                    } else {
                        iconmarkers["marker_" + mark.index] = "PROD_GEN";
                        window["marker_" + mark.index] = new google.maps.Marker(
                            {
                                position: position,
                                map: map,
                                icon: markerGeneral,
                                title: mark["title"]
                            }
                        );
                    }

                    if (bounds) {
                        bounds.extend(position);
                        map.fitBounds(bounds);
                        var listener = google.maps.event.addListener(
                            map,
                            "idle",
                            function() {
                                if (map.getZoom() > 9) map.setZoom(7);
                                google.maps.event.removeListener(listener);
                            }
                        );
                    }

                    // markers.push({key:'marker_'+mark.index,marker:window['marker_'+mark.index]})
                    markclust.push(window["marker_" + mark.index]);

                    window[
                        "infowindow_" + mark.index
                    ] = new google.maps.InfoWindow({
                        content: printMarker(mark)
                    });

                    google.maps.event.addListener(window["marker_" + mark.index],"click", function() {
                        if (lastOpenedInfoWindow) {
                            lastOpenedInfoWindow.close();

                            if (iconmarkers["marker_" + lastOpenedMarker] == "PROD_NC" || iconmarkers["marker_" + lastOpenedMarker] == "PROD_NCP")
                                window["marker_" + lastOpenedMarker].setIcon(markerNicolaus)
                            else
                                window["marker_" + lastOpenedMarker].setIcon(markerGeneral)
                        }
                        if (iconmarkers["marker_" + mark.index] == "PROD_NC") {
                            // console.log(mark)
                            window["marker_" + mark.index].setIcon(window.appUrl + "/images/marker-nc-click.svg");
                        }
                        else if (iconmarkers["marker_" + mark.index] == "PROD_NCP") {
                            // console.log(mark)
                            window["marker_" + mark.index].setIcon(window.appUrl +"/images/marker-ncprime-click.svg");
                        } else {
                            window["marker_" + mark.index].setIcon(window.appUrl +"/images/marker-gen-click.svg");
                        }

                        window["infowindow_" + mark.index].open(advmap,window["marker_" + mark.index]);
                        lastOpenedInfoWindow = window["infowindow_" + mark.index];
                        lastOpenedMarker = mark.index;
                    });
                }
            }
        });
        var markerCluster = new MarkerClusterer(map, markclust, {
            imagePath: window.appUrl + "/images/clustermap/m",
            maxZoom: 9,
            gridSize:40,
            minimumClusterSize: 2,
        });
    }
}

function printMarker(mark) {
    // console.log(mark)
    var htmlmap = '<a class="marker" href="' + mark.link + '">';
    htmlmap +=
        '<div class="image image-shadow" style="background-image:url(' +
        mark["img"] +
        ')">';
    htmlmap += '<div class="marker-header">';
    htmlmap += '<div class="list-stars">';
    for (let i = 0; i < mark["stars"]; i++) {
        htmlmap +=
            '<svg xmlns="http://www.w3.org/2000/svg" width="16.59" height="16.791" viewBox="0 0 19.59 19.791"><g transform="translate(-742.384 -1553.927)"><g transform="translate(742.384 1553.927)"><path fill="#fff" d="M5.128,6.834a.408.408,0,0,0,.579-.464L4.624-.605l4.591-4.94a.453.453,0,0,0-.221-.75L2.649-7.31l-2.84-6.349a.383.383,0,0,0-.716,0L-3.748-7.313-10.091-6.3a.453.453,0,0,0-.221.75L-5.72-.607-6.8,6.37a.409.409,0,0,0,.579.464L-.546,3.54Z" transform="translate(10.433 13.905)"/></g></g></svg>';
    }
    if (mark["superior"]) {
        htmlmap +=
            '<span class="d-inline-block" style="vertical-align: middle">'+mark["superior"]+'</span>';
    }
    /*if( mark["stars"] < 5 ) {
    for ($y = 0; $y < (5 - mark["stars"]); $y++) {
      htmlmap += '<svg xmlns="http://www.w3.org/2000/svg" width="16.59" height="16.791" viewBox="0 0 19.59 19.791"><g transform="translate(-742.384 -1553.927)"><g opacity="0.4" transform="translate(742.384 1553.927)"><path fill="#fff" d="M5.128,6.834a.408.408,0,0,0,.579-.464L4.624-.605l4.591-4.94a.453.453,0,0,0-.221-.75L2.649-7.31l-2.84-6.349a.383.383,0,0,0-.716,0L-3.748-7.313-10.091-6.3a.453.453,0,0,0-.221.75L-5.72-.607-6.8,6.37a.409.409,0,0,0,.579.464L-.546,3.54Z" transform="translate(10.433 13.905)"/></g></g></svg>';
    }
    }*/
    htmlmap += "</div>";
    htmlmap += '<h2 class="h2 mb-2">';
    if (mark.title !== "")
        htmlmap +=  mark["title"] + "<br>";
    htmlmap += "<b>" + mark["subtitle"] + "</b></h2>";
    htmlmap += '<div class="location"><svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="18.762" height="20.011" viewBox="0 0 18.762 26.011"><g transform="translate(0.583 0.5)"><path fill="#fff" stroke="rgba(0,0,0,0)" d="M2249.5,797.077a1.343,1.343,0,0,1-1.163-.673l-6.444-11.162a8.784,8.784,0,1,1,15.215,0l-6.446,11.164A1.341,1.341,0,0,1,2249.5,797.077Zm0-22.328a6.1,6.1,0,0,0-5.284,9.152l5.284,9.151,5.283-9.151a6.1,6.1,0,0,0-5.283-9.152Z" transform="translate(-2240.701 -772.066)"/><g transform="translate(5.695 5.934)"><path fill="#fff" stroke="rgba(0,0,0,0)" d="M2249.917,784.642a3.1,3.1,0,1,1,3.1-3.1A3.107,3.107,0,0,1,2249.917,784.642Zm0-4.455a1.352,1.352,0,1,0,1.352,1.352A1.353,1.353,0,0,0,2249.917,780.186Z" transform="translate(-2246.814 -778.435)"/></g></g></svg>';
    htmlmap += mark["locality"] + " (" + mark["region"] + ")" + "</div>";
    htmlmap += "</div>";
    
    if (typeof mark.treatments !== "undefined" || (typeof mark.beachDistance !== "undefined" && mark.beachDistance))
        htmlmap += '<div class="marker-footer">';
    else    
        htmlmap += '<div class="marker-footer bg-transparent">';
    if (typeof mark.treatments !== "undefined")
        htmlmap += '<div class=""><b>Trattamento</b> ' + mark.treatments + "</div>";
    if (typeof mark.beachDistance !== "undefined" && mark.beachDistance)
        htmlmap += '<div class=""><b>Distanza dal mare</b> ' + mark.beachDistance + " mt</div>";
    // }

    if (mark["type"] == "PROD_NC" || mark["type"] == "PROD_NCP") {
        
        if (typeof mark["club_feature"] !== "undefined" && mark["club_feature"].length) {
            htmlmap += '<div class="marker-icons">';
            for (let y = 0; y < mark["club_feature"].length; y++) {
                htmlmap += '<div class="border-icon">' + mark["club_feature"][y]["icon"] + "</div>";
            }
            htmlmap += "</div>";
        }

    }

    htmlmap += "</div>";

    htmlmap += "</div></a>";

    return htmlmap;
}





// ADV MAP
if ($("#advmap").length) {
    var lat = "42.188294";
    var lng = "12.677061";
    var myLatLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
    boundsadvmap = new google.maps.LatLngBounds();
    var myOptions = {
        zoom: 6,
        center: myLatLng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        panControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: true,
        overviewMapControl: false,
        rotateControl: false,
        zoomControl: true
    };
    advmap = new google.maps.Map(document.getElementById("advmap"), myOptions);
    advmap.setOptions({ styles: styles });
}
$("select[name='province']").on("change", function() {
    $(".loadresadv").show();
    var formdata = {};
    formdata["province"] = $(this).val();
    searchAdv(formdata);
});
$("#searchadv").on("click", function() {
    $(".loadresadv").show();
    var formdata = {};
    var caploc = $("input[name='caploc']").val();
    var province = $("select[name='province']").val();

    if (caploc) {
        if (/^([0-9]{5})$/.test(caploc)) formdata["cap"] = caploc;
        else formdata["location"] = caploc;
    }

    if (province) {
        formdata["province"] = province;
    }

    searchAdv(formdata);
});
function searchAdv(formdata) {
    $.ajax({
        type: "POST",
        url: window.appUrl + "/api/searchadv",
        dataType: "json",
        data: formdata,
        success: function success(result) {
            $("#listsadv").empty();
            $("#titlelistsadv").hide();
            $(".alert-advmap").hide();
            var lists = [];
            clearAdvMap();

            if (result.markers.length) {
                initMapAdv(result.markers);
            }

            $(".loadresadv").hide();
            $("html, body").animate(
                {
                    scrollTop: $("#advmap").offset().top - 350
                },
                800,
                function() {}
            );

            if (!result.advs.length && !result.markers.length) {
                $(".alert-advmap").show();
                $(".alert-advmap").toggleClass("show");
            }

            if (result.advs.length) {
                var html = "";
                result.advs.sort(function(a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }

                    if (a.name > b.name) {
                        return 1;
                    }

                    return 0;
                });
                $.each(result.advs, function(j, l) {
                    if (l.isDiamond) {
                        lists.push(l);
                    }
                });
                $.each(result.advs, function(j, l) {
                    if (!l.isDiamond) {
                        lists.push(l);
                    }
                });
                $("#titlelistsadv").show();
                $.each(lists, function(j, l) {
                    html += '<div class="col-md-4 mt20">';

                    if (l.isDiamond) {
                        html +=
                            '<div class="item-adv-dm gotomap" data-cx="' +
                            l.index +
                            '">';
                    } else html += '<div class="item-adv-n">';

                    html +=
                        '<div class="f-14 fw700 boxnameadv text-uppercase">' +
                        l.name +
                        "</div>";
                    html +=
                        '<div class="f-12 mt10 mb5">' +
                        l.address +
                        "," +
                        l.locality +
                        "</div>";

                    if (l.isDiamond) {
                        html +=
                            '<div  class="f-12 mb5">Tel. ' +
                            l.telephone +
                            "</div>";
                        html += '<div  class="f-12">' + l.email + "</div>";
                        html +=
                            '<div class="f-12 mt5 text-right boxadvsvg"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 100 100" role="img" aria-labelledby="icon-diamond-agency-description" class="icon-diamond-agency"><title id="icon-diamond-agency-description">Agenzia Viaggio Diamond icon</title> <path d="M41.31,21.29H32.2l7.64,7.87Zm26.73,0H62.52L60.6,32.42,73.88,27l-4-4.79A2.85,2.85,0,0,0,68,21.29Zm-7,0H42.82l-1.71,9.17L48,37.57l11-4.49ZM40.75,32.35,39.1,41.21l7.34-3ZM30.57,21.86a2.07,2.07,0,0,0-.37.34L17.53,37.34l8.89,9,11-4.52,2-10.82ZM58.66,35l-9.43,3.85,7.45,7.67ZM16.52,38.55,12.77,43a1,1,0,0,0-.09,1.09l.09.13L17.58,50l7.27-3Zm20.59,5.24-9.45,3.86L35,55.11ZM75,28.31l-14.7,6L58,47.82l8.75,9L81.65,51l5.65-6.75a1,1,0,0,0,0-1.22ZM57.93,49.91l-2,11.75,9.8-3.8Zm21.54,3.7L68,58.11l4.16,4.29ZM47.67,39.47l-8.92,3.65L36.27,56.4,45,65.3l9-3.53,2.3-13.36ZM26.09,48.29l-7.41,3L32.61,68l2-11Zm9.83,10L33.84,69.43l.15.18,9.44-3.69Zm17.81,5.38-7.46,2.91,5.92,6Zm12.63-4.94L55.34,63,53.47,73.89l4.88,5L71.1,63.61ZM53.15,75.8l-2,11.67,6.2-7.41Zm-8.47-8.61L35.1,70.93,49.52,88.17,51.87,74.5ZM50,1A49,49,0,1,1,1,50,49,49,0,0,1,50,1Zm1.56,88.39a2.1,2.1,0,0,1-1,.68,1.79,1.79,0,0,1-.51.07,1.87,1.87,0,0,1-.61-.11,2,2,0,0,1-.91-.64l-36.82-44a2.68,2.68,0,0,1-.6-1.74,2.73,2.73,0,0,1,.6-1.75L29.12,21.07a3.69,3.69,0,0,1,.57-.54,4.53,4.53,0,0,1,1-.58A3.52,3.52,0,0,1,32,19.63H68A4.25,4.25,0,0,1,71,21.07L88.37,41.89h0A2.68,2.68,0,0,1,89,43.64a2.64,2.64,0,0,1-.61,1.74Z" fill="#a99579" fill-rule="evenodd"></path></svg></div>';
                    }

                    html += "</div>";
                    html += "</div>";
                });
                $("#listsadv").html(html);
                $(".gotomap").on("click", function() {
                    if (lastOpenedInfoWindow) lastOpenedInfoWindow.close();
                    var index = $(this).data("cx");
                    advmap.setCenter(
                        new google.maps.LatLng(
                            window["marker_" + index].position.lat(),
                            window["marker_" + index].position.lng()
                        )
                    );
                    window["infowindow_" + index].open(
                        advmap,
                        window["marker_" + index]
                    );
                    lastOpenedInfoWindow = window["infowindow_" + index];
                    $("html, body").animate(
                        {
                            scrollTop: $("#advmap").offset().top - 350
                        },
                        800,
                        function() {}
                    );
                });
            }
        },
        error: function error(data) {}
    });
}

function clearAdvMap() {
    $.each(markersadvmap, function(m, mark) {
        mark.marker.setMap(null);
        delete window[mark.key];
    });
    advmap.setZoom(6);
    advmap.setCenter(new google.maps.LatLng(42.188294, 12.677061));

    markersadvmap = [];
    boundsadvmap = new google.maps.LatLngBounds();
}

function initMapAdv(markers) {
    var icon = new google.maps.MarkerImage(
        window.appUrl + "/images/diamond-agency.png",
        null,
        new google.maps.Point(0, 0),
        new google.maps.Point(30, 34)
    );

    var infoWindow = [];
    if (markers.length) {
        $.each(markers, function(m, mark) {
            var coords = mark["coords"];
            if (coords && typeof coords === "string") {
                var lt = coords.split(",")[0];
                var lg = coords.split(",")[1];

                var position = new google.maps.LatLng(
                    parseFloat(lt),
                    parseFloat(lg)
                );
                window["marker_" + mark.index] = new google.maps.Marker({
                    position: position,
                    map: advmap,
                    icon: icon,
                    title: mark["name"]
                });

                markersadvmap.push({
                    key: "marker_" + mark.index,
                    marker: window["marker_" + mark.index]
                });
                boundsadvmap.extend(position);
                var htmlmap =
                    '<div style="width:250px" class="advmap--infowindow"><h1>' +
                    mark["name"] +
                    "</h1>";
                htmlmap +=
                    '<div class="dark-grey-color f-12 mt10 font-c">' +
                    mark["address"] +
                    ", " +
                    mark["locality"] +
                    "</div>";
                htmlmap +=
                    '<div class="dark-grey-color f-12 font-c"><a class="dark-grey-color" href="tel:' +
                    mark["telephone"] +
                    '">' +
                    mark["telephone"] +
                    "</a></div>";
                htmlmap +=
                    '<div class="dark-grey-color f-12 mt5 font-c"><a class="dark-grey-color" href="mailto:' +
                    mark["email"] +
                    '">' +
                    mark["email"] +
                    "</a></div>";

                htmlmap += "</div>";

                window["infowindow_" + mark.index] = new google.maps.InfoWindow(
                    {
                        content: htmlmap
                    }
                );

                google.maps.event.addListener(
                    window["marker_" + mark.index],
                    "click",
                    function() {
                        if (lastOpenedInfoWindow) lastOpenedInfoWindow.close();
                        window["infowindow_" + mark.index].open(
                            advmap,
                            window["marker_" + mark.index]
                        );
                        lastOpenedInfoWindow =
                            window["infowindow_" + mark.index];
                    }
                );
            }
        });
        if (boundsadvmap.getNorthEast().equals(boundsadvmap.getSouthWest())) {
            var extendPoint1 = new google.maps.LatLng(
                boundsadvmap.getNorthEast().lat() + 0.01,
                boundsadvmap.getNorthEast().lng() + 0.01
            );
            var extendPoint2 = new google.maps.LatLng(
                boundsadvmap.getNorthEast().lat() - 0.01,
                boundsadvmap.getNorthEast().lng() - 0.01
            );
            boundsadvmap.extend(extendPoint1);
            boundsadvmap.extend(extendPoint2);
        }
        advmap.fitBounds(boundsadvmap);
        // var listener = google.maps.event.addListener(advmap, "idle", function() {
        //   if (advmap.getZoom() > 12) advmap.setZoom(12);
        //   google.maps.event.removeListener(listener);
        // });
    }
}






// module.exports = {
//     initDefaultMap: initDefaultMap,
//     initMap: initMap,
//     initMapAdv: initMapAdv,
// };
